angular.module('zc.zenclerkS')
  .component('zcsSidebar', {
    templateUrl: '/templates/zenclerk_s/layout/sidebar.html',
    controllerAs: 'vm',
    controller: zcsSidebar,
  });
zcsSidebar.$inject = ['$document', '$location', '$scope', '$state', 'Devise'];
function zcsSidebar($document, $location, $scope, $state, Devise) {
  const vm = this;
  // variables
  vm.currentUser = null;
  vm.state = {
    modal: false
  };
  // actions
  vm.logout = Devise.signOut;
  vm.toggleModal = toggleModal;

  this.$onInit = () => {
    // close modal with escape
    $document.on('keydown', closeProfile);
    $scope.$on('$destroy', () => $document.off('keydown', closeProfile));
  };

  this.$onDestroy = () => {
    $document.off('keydown', closeProfile);
  };

  // Modal
  // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
  function toggleModal() {
    vm.state.modal = !vm.state.modal;
    $('body').toggleClass('modal-open'); // prevent scrolling
    return true;
  }

  function closeProfile(e) {
    if(e.which === 27 && vm.state.modal) {
      vm.toggleModal();
      $scope.$apply();
    }
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/layout/sidebar.directive.js